import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_GESCON_SEF_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodos() {
        return axiosJwt
            .get(`${api}/gescon/gerentes/contratos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(contratoId) {
        return axiosJwt
            .get(`${api}/gescon/gerentes/contratos/${contratoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterSubItens(contratoId, itemContratoId) {
        return axiosJwt
            .get(`${api}/gescon/gerentes/contratos/${contratoId}/itens/${itemContratoId}/subitens`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDocumento(documento) {
        return axiosJwt
            .get(`${api}/gescon/gerentes/contratos/${documento.idContrato}/documentos/${documento.documentoContratoId}`, {
                responseType: 'blob'
            })
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterFasePorId(contratoId, faseContratoId) {
        return axiosJwt
            .get(`${api}/gescon/gerentes/contratos/${contratoId}/fases/${faseContratoId}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterComprometimento(contratoId, idComprometimento) {
        return axiosJwt
            .get(`${api}/gescon/gerentes/contratos/${contratoId}/comprometimentos/${idComprometimento}/rateios`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterTimeLine(codContrato, idComprometimento) {
        let url = `${api}/gescon/gerentes/contratos/${codContrato}/comprometimentos/${idComprometimento}/timeline`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterHistorico(idComprometimento) {
        let url = `${api}/gescon/gerentes/contratos/0/comprometimentos/${idComprometimento}/historico`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    exportarPlanilhaSubItens(contrato) {
        return axiosJwt
            .get(`${api}/gescon/gerentes/contratos/${contrato.idContrato}/itens/exportarplanilhasubitens`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterHistoricoAditivos(contratoId) {
        let url = `${api}/gescon/gerentes/contratos/${contratoId}/historicoaditivos`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
}
